import { create } from "zustand";

interface HookProps {
  open: boolean;
  repaymentRequestId: string;
  setRepaymentRequestId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const useTakeActionModal = create<HookProps>()((set) => ({
  open: false,
  repaymentRequestId: "",
  setRepaymentRequestId: (id) =>
    set(() => ({
      repaymentRequestId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
